import { colors } from '@ui/kit';
import { combineTokens, makeSurfaceToken, makeScalarToken } from '@utils/css';

const boxLayout1 = combineTokens("--text--layout-1", {
  borderStyle: ["unset", makeScalarToken],
  borderWidth: [0, makeScalarToken],
  surface: [{
    background: "0 0 0 / 0",
    border: "0 0 0 / 0",
    color: colors.text.primary
  }, makeSurfaceToken]
});
const boxLayout2 = combineTokens("--text--layout-2", {
  borderStyle: ["unset", makeScalarToken],
  borderWidth: [0, makeScalarToken],
  surface: [{
    background: "0 0 0 / 0",
    border: "0 0 0 / 0",
    color: colors.text.primary
  }, makeSurfaceToken]
});
const boxLayout3 = combineTokens("--text--layout-3", {
  borderStyle: ["unset", makeScalarToken],
  borderWidth: [0, makeScalarToken],
  surface: [{
    background: "0 0 0 / 0",
    border: "0 0 0 / 0",
    color: colors.text.primary
  }, makeSurfaceToken]
});
const snippetLayout = combineTokens("--text--snippet", {
  borderStyle: ["unset", makeScalarToken],
  borderWidth: [0, makeScalarToken],
  surface: [{
    background: "0 0 0 / 0",
    border: "0 0 0 / 0",
    color: colors.text.primary
  }, makeSurfaceToken]
});

export { boxLayout1, boxLayout2, boxLayout3, snippetLayout };
//# sourceMappingURL=box.js.map
